<template>
  
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="$router.push({ path: '/knowledge/index'})">首页</a-breadcrumb-item>
      <a-breadcrumb-item style="cursor: pointer;" @click="$router.push({ path: '/knowledge/institution/index'})">知识产权机构</a-breadcrumb-item>
      <a-breadcrumb-item  v-if="optionsData">{{optionsData.name}}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div v-if="optionsData" class="cont_body">
    <div class="list_cont">
      <div class="list_img">
        <img v-if="optionsData.logo" :src="getImg(optionsData.logo)" alt="">
        <img v-else src="@/assets/img/defaultPhoto.png" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.name}}</h4>
        <div class="list_cont_mid">
          <p>联系人：{{optionsData.contacts}}</p>
        </div>
        <div class="list_cont_mid">
          <p>地址：{{optionsData.workAddress	}}</p>
        </div>
      </div>
      <div class="collect" @click="onCollect(optionsData.name)" v-if="!collectShow">
          <StarOutlined/>
          收藏
      </div>
      <div class="collect" @click="oncancel" v-if="collectShow">
          <StarOutlined/>
          已收藏
      </div>
    </div>
  </div>
  <div v-if="optionsData" class="list_bottom">
    <div class="list-bottom-left">
      <h4>服务机构简介</h4>
      <p v-html="optionsData.introduction">
      
      </p>
    </div>
    
    <div class="list-bottom-right">
      <h4>服务机构评价</h4>
      <p>服务评分：<a-rate v-model:value="optionsData.score" disabled /></p>
      <p>机构评价：{{optionsData.scoreMsg		}}</p>
    </div>
  </div>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { dictMixin,formMixin } from "@/mixins";
import {collectWeb} from "@/api/innovationService";
import {innovationMechanismInfo,financeDocking,financeProject} from "@/api/knowledge";
import {file_service} from "@/api/adminService";
// import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: { 
    // DictRender
   },
  mixins: [formMixin,dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictNames: 'investmentField',
      optionsData:null,
      collectShow: false,
      lists: [],
      visible:false,
      role: null,
      form: {
          projectId: null,
          senderId: null,
          receiverId: null,
          senderContact: null,
          senderContactNumber: null,
          notes: null,
          processingState: null,
      },
      rules: {
          projectId: [dataCheck.required({})],
          senderId: [],
          receiverId: [],
          senderContact: [dataCheck.required({})],
          senderContactNumber: [dataCheck.required({}),dataCheck.phone],
          processingState: [dataCheck.required({})],
          notes: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return financeDocking.add
      }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: innovationMechanismInfo.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.form.receiverId = res.id
        this.form.senderId = this.$ls.get('notificationId')
        this.role = this.$ls.get('roleCode').replace("[","").replace("]","").replace("\"","").replace("\"","").replace("\"","").replace("\"","").split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
      })
    }
  },
	methods: {
    getProject() {
      this.getAction({
          url: financeProject.list,
          params: {
            id:this.$ls.get('companyCode')
          }
      }).then(res => {
        res.map(item => {
          this.lists.push({id:item.id,value:item.projectName})
        } )
      })
    },
    onAdd() {
            if(this.$ls.get('token')){
              this.visible=true;
            }
            this.form.senderContact=null,
            this.form.senderContactNumber=null,
            this.form.notes=null,
            this.getProject()
    },
    onCollect(title) {
      
      if(this.$ls.get('token')){
        let collUrl = window.location.href
            this.postAction({
                url: collectWeb.saveOrUpdate,
                params: {
                    title: title,
                    type: "4",
                    url: collUrl,
                    systemType: 'knowledge'
                }
            }).then(res => {
                console.log(res, 'res')
        this.$notification.success({
                                message: '收藏成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
      }else{
        
        this.$notification.warning({
                                message: '登录后可以操作',
                                style: {
                                    fontWeight: '600',
                                },
                            });
this.$router.push({ path: '/login', query: { id: 'user' } })
      }
        },
        getIsCollect() {
            this.getAction({
                url:collectWeb.Iscancel,
                params:{
                    urls:window.location.href,
                    systemType: 'knowledge'
                }
            }).then(res=>{
                this.collectShow = res
            })
        },
        
        oncancel(){
            this.postAction({
                url:collectWeb.romver,
                params:{
                    urls:window.location.href,
                    systemType: 'knowledge'
                }
            }).then(()=>{
              
        this.$notification.success({
                                message: '取消收藏',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                this.getIsCollect()
            })
        },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";

.list_cont{
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .collect {
    border:1px solid #2162e4;
    padding:6px 0;
    text-align: center;
    width:135px;
    color:#2162e4;
    font-size: 15px;
    position: absolute;
    right: 60px;
    cursor: pointer;
  }
  .list_img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    height:130px;
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    flex: 1;
    :deep(.ant-btn){
      font-size: 14px;
      background: #1890ff;
      color:#fff;
      border:none
    }
  }
}
.list_bottom{
  display: flex;
  .list-bottom-left{
    flex: 5;
  }
  .list-bottom-right{
    flex: 2;
    p{
      margin:30px 0
    }
  }
  h4{
    border-left: 4px solid #1890ff;
    padding-left: 15px;
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>